module.exports = __webpack_public_path__ + "static/watch-how-it-works-btn-29f7ea74e47de8b67a5830e2e4b952e7.svg";